document.addEventListener('alpine:init', () => {
    document.dispatchEvent(new Event('alpine:bundle'));
});